import { EqualValidator } from './equalValidator.directive';
import { CommonModule } from '@angular/common';
import { NgModule } from "@angular/core";
import { CurrentPasswordValidator } from './currentPasswordValidator.directive';
import { UniqueEmailValidator } from './uniqueEmailValidator.directive';
import { RightSwipeDirective } from './rightSwipe.directive';
import { LeftSwipeDirective } from './leftSwipe.directive';
import { MatFormFieldRequiredDirective } from './matFormFieldRequired.directive';
import { UniqueDomainValidator } from './uniqueDomain.directive';
import { MinNumberValidator } from './minNumber.directive';

@NgModule({
    imports: [
        CommonModule,
    ],
    declarations: [
        CurrentPasswordValidator,
        EqualValidator,
        UniqueEmailValidator,
        RightSwipeDirective,
        LeftSwipeDirective,
        MinNumberValidator,
        MatFormFieldRequiredDirective,
        UniqueDomainValidator
    ],
    exports: [
        CurrentPasswordValidator,
        EqualValidator,
        UniqueEmailValidator,
        RightSwipeDirective,
        LeftSwipeDirective,
        MatFormFieldRequiredDirective,
        MinNumberValidator,
        UniqueDomainValidator
    ]
})
export class DirectivesModule {
}